exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.email-account-badge {\n  vertical-align: inherit;\n  display: inline-block;\n  padding: 0.5rem;\n  margin: -.5rem 0;\n  border-radius: .2rem;\n  transition: background-color .5s;\n}\n.email-account-badge:hover {\n  background-color: #0000000a;\n}\n.email-account-badge .white-border {\n  border-radius: 100%;\n  border: solid white 2px;\n}\n", ""]);

// exports
